module.exports = __webpack_public_path__ + "img/bg_main_b.db988ff1.png";